import { AutogenModelActionCode, AutogenRowActionCode } from "./autogen/AutogenModelActionCode";

export class ModelActionCode extends AutogenModelActionCode<RowActionCode> {
	constructor() {
		super(RowActionCode);
	}
}

export class RowActionCode extends AutogenRowActionCode {
}